<template>
  <div>
    <div v-if="loading" class="mb-4">
      <v-progress-linear class="loading" indeterminate color="info" />
    </div>
    <div v-else class="d-flex justify-center">
      <v-data-table :headers="headers" :items="formatData" :search="search" :items-per-page="5" class="elevation-1 col-12 mb-4">
        <template #top>
          <v-text-field v-model="search" label="Rechercher" class="col-4" />
        </template>
      </v-data-table>
    </div>
  </div>
</template>
<script setup>
import gql from 'graphql-tag';
import { ref, computed, onMounted } from 'vue';
import moment from 'moment';

import { useQuery, useApolloClient } from '@vue/apollo-composable';
import { useStore } from 'vue2-helpers/vuex';
// eslint-disable-next-line no-undef
const props = defineProps({ iresaCode: { type: String, default: '' } });
const search = ref('');
const store = useStore();
const { resolveClient } = useApolloClient();
const headers = [
  {
    text: 'Date début',
    align: 'start',
    value: 'date',
    width: '20%'
  },
  {
    text: 'Timestamp',
    align: 'timestamp',
    value: 'timestamp',
    width: '15%'
  },
  {
    text: 'Hébergement',
    align: 'start',
    value: 'idHebergement',
    width: '5%'
  },
  {
    text: 'Stock Dispo',
    align: 'start',
    value: 'availableStock',
    width: '20%'
  },
  {
    text: 'Availabel',
    align: 'Start',
    value: 'availability',
    with: '5%'
  },
  {
    text: 'Prix Final',
    align: 'start',
    value: 'price',
    width: '15%'
  }
  // {
  //   text: 'Code',
  //   align: 'start',
  //   value: 'code'
  // }
];

const loading = ref(true);
const offers = ref([]);
async function getOffers () {
  // GET PROJECT
  const project = store.state.environment.PROJECT;

  // FIND BASE PROJECT CONFIG
  const workspaceSettings = store.state.workspaces.find(pr => pr.code === project);

  try {
    const marque = workspaceSettings && workspaceSettings.settings?.iresaMarque ? workspaceSettings.settings.iresaMarque : 1;
    const query = `query ${project}IresaGetOffers {iresaGetOffers(iresaCode: ${props.iresaCode}, marque: ${marque}) { code idHebergement date availableStock availability price }}`;
    const ApolloClient = resolveClient();
    const result = await ApolloClient.query({ query: gql(query), fetchPolicy: 'no-cache', errorPolicy: 'ignore', notifyOnNetworkStatusChange: true });

    if (result.data.iresaGetOffers) {
      offers.value = result.data.iresaGetOffers;
    }
    loading.value = false;
  } catch (e) {
    console.log('[ERROR] iresaGetOffers ->', e);
    loading.value = false;
  }
}

const formatData = computed(() => offers.value.map(o => {
  o.timestamp = o.date;
  o.date = moment(o.date, 'X').format('DD-MM-YYYY');
  return o;
}));

onMounted(async () => {
  await getOffers();
});
</script>
